import CLASS_VERSION from 'Common/constants/classVersion'

// Be aware that theses names match the BE way of creating the content types (content.class.name)
export const CONTENT_TYPES = {
  course: 'Course',
  flashcardCategory: 'FlashcardCategory',
  flashcardSet: 'FlashcardSet',
  lesson: 'Lesson',
  post: 'Post',
  video: 'Video',
}

// Resource types that are only available for kanban classes
export const CONTENT_CLASS_VERSIONS = {
  [CONTENT_TYPES.video]: CLASS_VERSION.kanban,
  [CONTENT_TYPES.course]: CLASS_VERSION.kanban,
}

export const CONTENT_LABELS = {
  [CONTENT_TYPES.flashcardCategory]: 'Flashcard Category',
  [CONTENT_TYPES.flashcardSet]: 'Flashcard Set',
  [CONTENT_TYPES.lesson]: 'Lesson',
  [CONTENT_TYPES.course]: 'Study Pack',
  [CONTENT_TYPES.video]: 'Video',
  [CONTENT_TYPES.post]: 'Blog',
}

export const CONTENT_COUNT_COPY = {
  [CONTENT_TYPES.course]: {
    singular: 'Lesson',
    plural: 'Lessons',
  },
  [CONTENT_TYPES.flashcardCategory]: {
    singular: 'Flashcard',
    plural: 'Flashcards',
  },
  [CONTENT_TYPES.flashcardSet]: {
    singular: 'Flashcard',
    plural: 'Flashcards',
  },
}

export const COURSE_TYPES = {
  pack: 'pack',
  course: 'course',
}

export const COURSE_TYPE_LABELS = {
  [COURSE_TYPES.course]: 'Course',
  [COURSE_TYPES.pack]: 'Study Pack',
}

export const COURSE_TYPE_ICONS = {
  [COURSE_TYPES.pack]: 'backpack',
  [COURSE_TYPES.course]: 'graduation-cap',
}

export const CONTENT_TYPES_URL = {
  [CONTENT_TYPES.lesson]: `/routes/lesson/`,
  [CONTENT_TYPES.video]: `/routes/video/`,
  [CONTENT_TYPES.flashcardCategory]: `/routes/flashcard_category/`,
  [CONTENT_TYPES.flashcardSet]: `/flashcard_player/?flashcard_set= `,
}
